module.exports = __webpack_public_path__ + "img/img2.a9e841c3.jpg";